// src/helpers/base64Utils.js
import CryptoJS from "crypto-js";

// UTF-8 stringi Base64'e encode et
export function encodeUtf8Base64(utf8str) {
  const wordArray = CryptoJS.enc.Utf8.parse(utf8str);
  return CryptoJS.enc.Base64.stringify(wordArray);
}

// Base64 stringi decode edip UTF-8 stringe çevir
export function decodeBase64Utf8(base64) {
  const wordArray = CryptoJS.enc.Base64.parse(base64);
  return CryptoJS.enc.Utf8.stringify(wordArray);
}

// Base64 URL-safe → standart Base64 dönüşümü ve padding ekleme
export function base64UrlToBase64(base64url) {
  let base64 = base64url.replace(/-/g, "+").replace(/_/g, "/");
  const pad = base64.length % 4;
  if (pad > 0) {
    base64 += "=".repeat(4 - pad);
  }
  return base64;
}
